import Head from 'next/head'

import { isToggleEnabled } from 'configs/toggle-feature'
import InfoTerkini from 'app/InfoTerkiniPage/InfoTerkini'
import { getDeviceId } from 'utils/deviceId'

export async function getServerSideProps(ctx) {
  const isRuangGtkEnabled = await isToggleEnabled('ruang-gtk-enabled')

  return {
    props: {
      appDeviceID: getDeviceId(ctx),
      isRuangGtkEnabled,
    },
  }
}

export const InfoTerkiniPage = ({ isRuangGtkEnabled }) => {
  return (
    <>
      <Head>
        <title>Info Terkini - Ruang GTK</title>
      </Head>

      <InfoTerkini isRuangGtkEnabled={isRuangGtkEnabled} />
    </>
  )
}

InfoTerkiniPage.layoutOpts = {
  hasHeader: false,
}

export default InfoTerkiniPage
